import React, { Component } from "react";
import {Helmet} from 'react-helmet'
import TabsOne from "./component/tabs/TabsOne";
import TabsTwo from "./component/tabs/TabsTwo";
import TabsThree from "./component/tabs/TabsThree";
import Breadcrumb from "../components/common/Breadcrumb";

class Tabs extends Component{
    render(){
        return(
            <div>
                <Helmet>
                    <title>Tabs || Aeroland React Multipurpose React Template</title>
                    <meta name="description" content="Aeroland – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Aeroland Bootstrap 4 Template will create that various landing Template." />
                </Helmet>

                {/* Start Breadcrumb Area */}
                <Breadcrumb title={'Tabs'} />
                {/* End Breadcrumb Area */}

                {/* Start Tabs Area */}
                <div className="tabs-area ptb--120">
                    <TabsOne />
                </div>
                {/* End Tabs Area */}

                {/* Start Tabs Area */}
                <TabsTwo />
                {/* End Tabs Area */}

                <TabsThree />
            </div>
        )
    }
}
export default Tabs;